import styled from '@emotion/styled'

const DialogsContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  height: 95%;
  overflow-y: scroll;
  padding: 8px 0 0 8px;
`

export default DialogsContainer
